

























































































import {
  Component,
  Prop,
  Vue,
  Watch
} from "@/shared/vuepack";

import HsabExpenseForm from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseForm.vue";
import HsabExpenseTable from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseTable.vue";
import { useHsabExpenseStore } from "@/employee/store/hsabExpense";
import { useUserStore } from "@/shared/store/user";
import * as RouteNames from "@/employee/route-names";
import { useThemeStore } from "@/shared/store/theme";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import HsabExpenseEditModal from "@/employee/components/landing-pages/hsabank/expense/hsabExpenseCard/HsabExpenseEditModal.vue";
import { useManagedExpenseStore } from "@/employee/store/managedExpense";
import ManagedExpenseTable from "@/employee/components/landing-pages/hsabank/expense/ManagedExpenseTable.vue";
import { useContactInfoStore } from "@/shared/store/contactinfo";
import ManagedExpenseFilters from "@/employee/components/landing-pages/hsabank/expense/ManagedExpenseFilters.vue";
import {
  FetchState,
  HsabAccountNametag,
  HsabSsoDestination,
  ManagedExpenseFilterType
} from "@/shared/types";
import HsabExpenseEvidenceShoeboxModal from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseEvidenceShoeboxModal.vue";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import { useDistributionSchedulesStore } from "@/shared/store/distributionSchedules";
import { useHsabEnrollmentStore } from "@/employee/store/hsabEnrollment";
import { useHsaDailyBalanceStore } from "@/shared/store/hsaDailyBalance";
import moment from "moment";
import _ from "lodash";
import { formatCurrency } from "@/shared/currency";

@Component({
  components: {
    SsoDeepLink,
    HsabExpenseEditModal,
    HsabExpenseTable,
    HsabExpenseEvidenceShoeboxModal,
    ManagedExpenseFilters,
    ManagedExpenseTable,
    HsabExpenseForm
  }
})
export default class HsabExpenseManagement extends Vue {
  hsabExpense = useHsabExpenseStore();
  userStore = useUserStore();
  hsabAccountsStore = useHsabAccountsStore();
  RouteNames = RouteNames;
  themeStore = useThemeStore();
  contactInfoStore = useContactInfoStore();
  managedExpensesStore = useManagedExpenseStore();
  flagStore = useFeatureFlagStore();
  distributionSchedulesStore = useDistributionSchedulesStore();
  hsabEnrollmentStore = useHsabEnrollmentStore();
  balanceStore = useHsaDailyBalanceStore();
  formatCurrency = formatCurrency;
  ssoDestination = HsabSsoDestination;
  showOpenShoeboxModalButton = false;

  showCreateModal = false;

  @Prop({ default: () => ManagedExpenseFilterType.MyExpenses })
  filter: ManagedExpenseFilterType;

  @Watch("$props.filter")
  onFilterChange () {
    this.managedExpensesStore.setBaseFilterType(this.filter);
  }

  mounted () {
    this.contactInfoStore.getContactInformation();
    this.managedExpensesStore.loadManagedExpensesByPage(1, this.filter);
    this.distributionSchedulesStore.getDistributionSchedules();
    this.balanceStore.loadBalanceOnFile();
    this.loadClaimExchangeSettings();
  }

  get hasMedicalPlan () {
    const plansAndSubTypes = this.hsabAccountsStore.allActivePlanTypesAndSubTypes;
    return plansAndSubTypes && plansAndSubTypes.hasMedicalPlan;
  }

  get shouldCheckHealthcareClaimSettings () {
    return this.flagStore.flags.bend20914DeepLinkForManageHealthcareClaims;
  }
  get showManageHealthcareClaims () {
       const planTypesAndSubtypes = this.hsabAccountsStore.allActivePlanTypesAndSubTypes;
       return ((!this.hsabEnrollmentStore.settings && this.hsabEnrollmentStore.settingsFetchState === FetchState.Failed) || (this.hsabEnrollmentStore.settings &&
           (this.hsabEnrollmentStore.settings.allowOptInOutAutoClaims ||
           this.hsabEnrollmentStore.settings.enableAutomaticallyFiled) && planTypesAndSubtypes
           && planTypesAndSubtypes.allowHealthcareClaims === true ));
  }

  get disableManageHealthcareClaimsDeepLink () {
    return this.flagStore.flags.bend20914DeepLinkForManageHealthcareClaims && this.hsabEnrollmentStore.settings === null
        && this.hsabEnrollmentStore.settingsFetchState === FetchState.Failed;
  }

  get showExportAllExpensesButton () {
    return this.flagStore.flags.bend21900ExportAllExpenses;
  }

  get showExportFilteredExpensesButton () {
    return this.flagStore.flags.bend21900ExportFilteredExpenses;
  }

  loadClaimExchangeSettings () {
    if (this.shouldCheckHealthcareClaimSettings) {
      this.hsabEnrollmentStore.loadHsabEnrollmentSettings();
    }
  }

  addExpenseAction (event: any) {
    this.showCreateModal = true;
  }

  handleCloseAction () {
    this.showCreateModal = false;
  }

 get showPlaceCommuterOrderButton (): boolean {
    if (this.flagStore.flags.bend20033DisplaySmartCommuteDeepLink) {
      const planTypesAndSubtypes = this.hsabAccountsStore.allActivePlanTypesAndSubTypes;
      return planTypesAndSubtypes
          && planTypesAndSubtypes.hasSmartCommutePlan === true;
    }
    return false;
  }

  get showManageDistributionsButton (): boolean {
    return this.distributionSchedulesStore.schedulesLoaded && this.distributionSchedulesStore.hasSchedules;
  }
  get cashAccountBalanceLoaded (): boolean {
    return this.balanceStore.balanceOnFileLoaded && this.balanceStore.balanceOnFileLoaded;
  }

  get showCashBalance (): boolean {
    return this.hsabAccountsStore.userHasHsaAccount
      && this.flagStore.featureFlagsAvailable
      && this.flagStore.flags.bend21410DisplayHsaBalanceOnExpenseManagement;
  }

  get isHsaOnly (): boolean {
    return this.hsabAccountsStore.isHsaOnly;
  }

  formatPlanName (plan: HsabAccountNametag) {
    if (plan.bankAccountType === "hsa") {
      return "Health Savings Account (Cash Account)";
    }
    return `${plan.accountName} (${moment(plan.startDate).format("YYYY")})`;
  }

  get activePlans () {
    return _.orderBy(this.hsabAccountsStore.allActiveHsabAccounts, [i => i.bankAccountType, i => i.accountName], [ "asc", "asc" ]);
  }

  get cashAccountBalance (): number {
    return this.balanceStore.instantBalance.amount || this.balanceStore.balanceOnFileAmount;
  }

  onManagedDistributionsActionClicked () {
    const btn = this.$refs.btnManagedDistributions as HTMLElement;
    btn.click();
  }

  onPlaceCommuterOrderActionClicked () {
    const btn = this.$refs.btnPlaceCommuterOrder as HTMLElement;
    btn.click();
  }

  onManageHealthcareClaimsClicked () {
    const btn = this.$refs.btnManageHealthcareClaims as HTMLElement;
    btn.click();
  }

  onOpenShoeboxModalClicked () {
    const modal: any = this.$refs.shoeboxModalComponent;
    const btn = modal.$refs.btnOpenShoeboxModal;
    btn.click();
  }

  onShoeboxModalHasItemsUpdate (val) {
    this.showOpenShoeboxModalButton = val;
  }

  onExportAllExpensesClicked () {
    this.managedExpensesStore.exportAllManagedExpenses();
  }

  onExportExpensesWithCurrentFiltersClicked () {
    this.managedExpensesStore.exportCurrentlyFilteredManagedExpenses();
  }
}
